import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { reduceResolution, wbp } from 'Theme';

export const useSingleSaleTableItemQuantityStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {},

        boxQty: {
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0
        },

        typoQty: {
            display: 'flex',
            [theme.breakpoints.down(wbp)]: {
                paddingRight: `${reduceResolution(17)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                paddingRight: '17px'
            }
        },

        qtyButton: {
            display: 'flex',
            flexShrink: 0
        },

        sectionIconQty: {
            'fontSize': 20,
            'display': 'flex',
            'flexShrink': 0,

            '&:hover': {
                cursor: 'pointer'
            }
        },

        typoAmount: {
            fontSize: 16,
            textAlign: 'center',
            flexShrink: 0,
            whiteSpace: 'nowrap',
            padding: '0px 16px',

            [theme.breakpoints.up('md')]: {
                minWidth: '2ch',
                paddingLeft: '10px',
                paddingRight: '10px'
            }
        }
    })
);
